<style lang="scss" scoped>
	// @import "./establishPage.css";
	@import "./custinforma.css";
</style>
<style lang='scss'>
    *, *::before, *::after{
        font-family: 'element-icons';

    }
    .confirmbtn{
        color: #FFFFFF !important;
        background-color: #09666e!important;
        border-color: #09666e!important;
    }
    .el-button--small:hover{
        background-color: #ffffff ;
        border-color: #dcdfe6 ;
        color: #000;
    }

</style>
<template>
	<div id="custinforma">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify='space-between'>
					<a-col :xl="{ span: 7 }">
						<a-form-model-item label="證券帳號" class="formItem">
							<a-input v-model="params.username" placeholder="請輸入證券帳號"  :allowClear="true" @change="handleClear(1)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 7 }">
						<a-form-model-item label="交易編號" class="formItem">
							<a-input v-model="params.tradecode" placeholder="請輸入交易編號" :allowClear="true" @change="handleClear(2)"/>
						</a-form-model-item>
					</a-col>
					<!-- <a-col :xl="{ span: 5 }">
						<a-form-model-item label="提存日期" class="formItem">
							<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
								v-model="params.timeDate" @change='fanhand'>
							</a-range-picker>
						</a-form-model-item>
					</a-col> -->

					<a-col :xl="{ span: 7 }">
						<a-form-model-item label="提存/兌換" class="formItem">
								<a-select v-model="params.tradetype" placeholder=" " @change='messLoad()'>
									<a-select-option v-for="(item,ind) in tradetypeArr" :key="ind+''" :value="item.x">
										{{item.v}}</a-select-option>
								</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<br>
				<a-row type='flex' justify='space-between'>
					<!-- <a-col :xl="{ span: 5 }">
						<a-form-model-item label="交易市场" class="formItem">
							<a-select v-model="params.market" placeholder="請選擇交易市场">
								<a-select-option v-for="(item) in admintypeArr" :key="item" :value="item">
									{{item}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col> -->
					<a-col :xl="{ span: 7 }">
						<a-form-model-item label="信息查詢" class="formItem">
							<a-input v-model="params.otherinfo" placeholder="請輸入電話號碼 / 電郵地址"  :allowClear="true" @change="handleClear(3)"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 7 }">
						<a-form-model-item label="提交時間" class="formItem">
							<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
								v-model="params.trade_date" @change='fanhand' style="width:100%">
							</a-range-picker>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 7 }" style="display: flex;align-items: center;">
						<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
							<img src="../../image/icon_sousuo.png" class="btnIcon" />
							<span>搜索</span>
						</div>
						<div class="btn_cla" style="background-color:#ffa647;"
							@click="clearEvent">
							<img src="../../image/icon_chongzhi.png" class="btnIcon" />
							<span>重置</span>
						</div>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<!-- <a-button class="bottomBtn" style="background-color:#ed4849;">
					<img src="../../image/icon_shanchu.png" class="btnIcon" />
					<span>刪除</span>
				</a-button> -->
				<a-button v-if='ipoAdmin&&false' class="bottomBtn" style="background-color:#ffa647;">
					<img src="../../image/icon_xiazai.png" class="btnIcon" />
					<span>下載</span>
				</a-button>
				<!-- @click='handpdf' -->
				<button class="bottomBtn" @click="upClick()" style="border:none;background: transparent;cursor: pointer;">
					<a-icon
					type="file-pdf"
					style="
						width: 0.9rem;
						color: #3bc7a1;
						margin-right: 0.5rem;
						fontsize: 0.8rem;
					"
					/>
					<span style="color: #3bc7a1;">導出</span>
				</button>

				<a-upload name="file" v-if="depositImport" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
					class="avatar-uploader" :show-upload-list="false"
					:before-upload="beforeUpload" @change="handleChange" :action="$api.importDepositAndExchange">
					<div class="bottomBtn" style="cursor: pointer;">
						<img src="../../image/endexs.png" class="btnIcon" />
						<span style="color:#4ea9e8;font-size: 0.8rem;">導入</span>
					</div>
				</a-upload>

				<button class="bottomBtn"  @click='exchange' style="border:none;background: transparent;cursor: pointer;"  v-if="!depositImport">
					<img src="../../image/huilv/huilv.png" class="btnIcon" />
					<span style="color: #ffa647;">匯率</span>
				</button>
				<button class="bottomBtn"  @click='depositFlag = true' style="border:none;background: transparent;cursor: pointer;" v-if="useradmin || !depositImport">
					<img src="../../image/huilv/lc.png" class="btnIcon" />
					<span style="color: #608be8;">添加提存兌換</span>
				</button>
				<task :params='params' @child='fandfn'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData"
				:customRow='rowstely'
				:rowKey='(record, index) => index' id='fromtable' :pagination="false" :bordered="true"
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }">
				<span slot='alltext' style="position: relative;left: -1.5rem;"></span>
				<!-- <div slot='tradetype' slot-scope="record" :style="{color:record.tradetype==1?'#35c62e':'#fa2c39'}" >
				{{record.tradestr}} <img v-if="record.remarkflag" :src="icon_remark" alt="" style="margin-left:10px;vertical-align: sub;width:18px"/>
				</div> -->
				<div slot='tradetype' slot-scope="record">
					<div v-for="(item,index) in record.priceList" :key="index">
						<div :style="{color:item.tradetype==1?'#fa2c39':'#35c62e'}">{{item.tradestr2}}</div>
					</div>
				</div>
				<!-- 显示状态 -->
				<!-- <div slot='market' slot-scope="record" :style="{color:record.cancelflag==1?'#999':''}" style='text-align: center;'>{{record.market}} -->
				<!-- </div> -->
				<div slot="schedule" slot-scope="record">
					<div class="tableRowView1" v-if="record.whichoperator == 1">
						<img src="../../image/icon/icon4.png" alt="" class="imageC">
						<div class="lineC"
							:style="!(record.schedule == 2&&record.handle == 2)&&(record.schedule >1&&record.handle == 1) ? 'background:#6cce68;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule == 3? icon_three : icon_three1" alt="" class="imageC">
						<div class="lineC" :style="record.schedule == 3 ? 'background:#f7d429;' : ''">
						</div>
						<img :src="record.schedule == 3? icon_four : icon_four1" alt="" class="imageC">
					</div>
					<div class="tableRowView1" v-else>
						<img :src="record.schedule > 0? icon_one : icon_one1" alt="" class="imageC">
						<div class="lineC"
							:style="!(record.schedule == 1&&record.handle == 2)&&(record.schedule >= 1&&record.handle >= 1)||(record.schedule >= 1&&record.handle ==0)? 'background:#467fff;' : ''">
							<span v-if="record.schedule == 1&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule == 3 ? icon_three : icon_three1" alt="" class="imageC">
						<div class="lineC"
							:style="!(record.schedule == 2&&record.handle == 2)&&(record.schedule >1&&record.handle == 1) ? 'background:#f7d429;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule == 3? icon_four : icon_four1" alt="" class="imageC">
					</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<!-- <div class="tableRowView2">
						<div class="popoverView">
							<metemail :ipoAdmin='ipoAdmin' :record='record' :missionflag='params.missionflag'
								@child='handclose'></metemail>
						</div>
						<div class="popoverView">
							<ediotable :record='record' @child='handclose'></ediotable>
						</div>
						
					</div> -->
					<!-- <div class="popoverView popoverView3">
							<pushbtn :record='record' @child='handclose' :params='params' ></pushbtn>
					</div> -->
					<div class="tableRowView2">
						<div>
							<img :src="require('@/image/icon_xiangqing.png')" class="imageC" @click="detailsClick(record)">
							<!-- <metemail :ipoAdmin='ipoAdmin' :record='record' :missionflag='params.missionflag'
								@child='handclose'></metemail> -->
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow?'pdfShow':'']" @click='pdfShowUNEvent()'>
			<div class='pdfviewIn'>
				<div class='pdfTitle'>
					<img src="../../image/icon_dayin.png" alt=""  @click.stop="printEvent()">
				</div>
				<iframe id='iframePdf1' :src='allurl' style='width:100%;height:100%;' frameborder='0'></iframe>
				<iframe id='toPrintIframe' style='display:none' :src='pdfBolUrl' frameborder='0'></iframe>
			</div>
		</div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<customerInformation v-if="customerInfoFlag" @child="customerInfoClick" :items='isdate'></customerInformation>
		<exchangeRate v-if="exchangeRateFlag" @child="exchangeRateClick" :items='isdate'></exchangeRate>
		<deposit v-if="depositFlag" @child="depositClick" :items='isdate'></deposit>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
	
</template>
<script>
	import exportData from "./components/exportData";
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_one from '../../image/icon/icon1.png';
	import icon_one1 from '../../image/icon/icon1.png';
	import icon_two from '../../image/icon/icon2.png';
	import icon_two1 from '../../image/icon/icon2_1.png';
	import icon_three from '../../image/icon/icon3.png';
	import icon_three1 from '../../image/icon/icon3_1.png';
	import icon_four from '../../image/icon/icon5.png';
	import icon_four1 from '../../image/icon/icon5_1.png';
	import icon_remark from '../../image/icon_remark.png';
	import customerInformation from "./components/customerInformation";
	import exchangeRate from "./components/exchangeRate";
	import deposit from "./components/deposit";

	import metemail from './components/metemail'
	import metemails from './components/metemails'
	import pushbtn from './components/pushbtn.vue'
	import ediotable from './components/ediotable.vue'
	import task from './components/task.vue'

	
	export default {
		components: {
			pushbtn,
			ediotable,
			metemail,
			metemails,
			task,
			customerInformation,
			exchangeRate,
			deposit,
			exportData
		},
		
		data() {
			return {
				upFlag:false,
				ishandout: false,
				isdate:null,
				customerInfoFlag: false,
				exchangeRateFlag: false,
				depositFlag: false,
				allurl:'',
				pdfShow:false,
				pdfBolUrl:'',
				pdfUrl : '',
				blob:'',
				icon_one,
				icon_one1,
				icon_two,
				icon_two1,
				icon_three,
				icon_three1,
				icon_four,
				icon_four1,
				icon_remark,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限  审批管理员 审批权限
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				useradmin: this.$store.state.rolesdata.indexOf('useradmin') >= 0,
				depositImport: this.$store.state.rolesdata.indexOf('depositImport') >= 0,
				admintypeArr: [],
				tradetypeArr:[
					{v:'全部',x: ''},
					{v:'存款',x: '0'},
					{v:'提款',x: '1'},
					// {v:'存款備註',x: '2'},
					// {v:'提款備註',x: '3'},
					{v:'貨幣兌換',x: '4'},
				],
				tzPageNum: '',
				selectedRows: [], //checkbox
				columns: [
					// {
					// 	// title: '',//
					// 	dataIndex: '',
					// 	align: 'left',
					// 	width: '4%',
					// 	slots: {
					// 		title: 'alltext'
					// 	},
					// 	// ellipsis:true,
					// },
					{
						title: '證券帳號',
						dataIndex: 'username',
						align: 'center',
						width: '6%'
					},
					{
						title: '交易編號',
						dataIndex: 'tradecode',
						align: 'center',
						width: '10%'
					},
					
					{
						title: '提交時間',
						dataIndex: 'createtime',
						align: 'center',
						width: '12%'
					},
					{
						title: '操作人員',
						dataIndex: 'handleadmin',
						align: 'center',
						width: '10%'
					},
					{
						title: '提存/兌換',
						dataIndex: 'tradetypestr',
						align: 'center',
						width: '12%'
					},
					// {
					// 	title: '交易市場',
					// 	dataIndex: '',
					// 	align: 'center',
					// 	width: '12%',
					// 	scopedSlots: {
					// 		customRender: 'market'
					// 	}
					// },
					{
						title: '交易金額',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots:{
							customRender:'tradetype'
						}
					},
					{
						title: '提存進度',
						dataIndex: '',
						align: 'center',
						width: '20%',
						scopedSlots: {
							customRender: 'schedule'
						}
					},
					{
						title: '審批時間',
						dataIndex: 'aduit_date',
						align: 'center',
						width: '8%'
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: '20%               	',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					otherinfo: '',
					perPage: 10, //每頁條目數
					username: '',
					market: '',
					trade_date: [],
					trade_date_begin: '', //認購起始日期
					trade_date_end: '', //認購截止日期
					createdate_begin: '',
					createdate_end: '',
					timeDate: [],
					missionflag: false,
					tradetype:''
				}
			}
		},
		
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
			this.getlist()
		},
		methods: {
			upClick(){
				this.upFlag = true
			},
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.handpdf(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			// 表格导出下载
			queryData(val){
				let brr =[];
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['id']){
						brr.push(this.columnsData[ev]['id'])
					}
				})
				let url = ''
				let _this = this;
				let sort =  val == undefined ? "" : val
				url = _this.$api.exportDepositAndExchange;
				url += '?otherinfo='+this.params.otherinfo
				url += '&username='+this.params.username
				url += '&market=' + this.params.market
				url += '&trade_date_begin=' + this.params.trade_date_begin
				url += '&trade_date_end=' + this.params.trade_date_end
				url += '&createdate_begin=' +this.params.createdate_begin
				url += '&createdate_end=' + this.params.createdate_end
				url += '&tradetype=' + this.params.tradetype
				url += '&token=' + this.$store.state.token
				url += '&sort=' + sort
				url += '&idList=' + brr.join(',')
				url += '&m=' + Date.parse(new Date())
				console.log(url);
				window.location.href = url;
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if (val == 1) {
					if (!this.params.username) {
						this.messLoad()
					}
				}
				if (val == 2) {
					if (!this.params.tradecode) {
						this.messLoad()
					}
				}
				if (val == 3) {
					if (!this.params.otherinfo) {
						this.messLoad()
					}
				}
            },
			exchange(){
				this.exchangeRateFlag = true;
			},
			handpdf(pxfs){
				let brr  = [];
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['aduitid']){
						brr.push(this.columnsData[ev]['aduitid'])
					}
				})
				let str = this.$api.pdfs;
				let url = this.$api.getQmisUserTCPdf;
				let sort =  pxfs == undefined ? '' : pxfs
				url += '?otherinfo='+this.params.otherinfo
				url += '&username='+this.params.username
				url += '&market=' + this.params.market
				url += '&trade_date_begin=' + this.params.trade_date_begin
				url += '&trade_date_end=' + this.params.trade_date_end
				url += '&createdate_begin=' +this.params.createdate_begin
				url += '&createdate_end=' + this.params.createdate_end
				url += '&tradetype=' + this.params.tradetype
				url += '&token=' + this.$store.state.token
				url += '&sort=' + sort
				url += '&idList=' + brr.join(',')
				url += '&m=' + Date.parse(new Date())
				this.allurl = str + url;
				let _this = this;
				_this.pdfUrl = url;
				https.fetchGetPdf(_this.pdfUrl).then((data)=>{
					let blob = new Blob([data],{
						type:'application/pdf'
					})
					let b=window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err=>{
					console.log(err)
				})
				setTimeout(()=>{
					this.pdfShow = true
				},500)
			},
			printEvent(){
			    let _this = this;
			    const printIframe = document.getElementById("toPrintIframe");
			    let frameWindow = printIframe.contentWindow;
			    frameWindow.print();
			    setTimeout(()=>{
			        window.URL.revokeObjectURL(_this.blob);
			    },500)
			},
			pdfShowUNEvent(){
				this.pdfShow = false
				// this.messLoad()
			},
			rowstely(record, index) {
				if (record.schedule == 3||(record.schedule == 1&&record.handle == 2)
				||(record.schedule == 2&&record.handle == 2)) {
					return {
						style: {
							'color': '#999',
							opacity: '.5'
						},
					}
				}
			},
			fandfn(val) {
				if (val == 'back') {
					this.params.missionflag = false
					this.params.tradetype = ''
				} else {
					this.params.missionflag = true
					if (val == '存款') {
						this.params.tradetype = '0'
					}else if (val == '提款') {
						this.params.tradetype = '1'
					}else{
						this.params.tradetype = '4'
					}
					// this.params.tradetype = val == '存款' ? '0' : '1'
				}
				this.messLoad()
			},
			getlist() {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": 'market'
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.admintypeArr = res.data.result
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			//点击checkbox
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			//跳轉
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.trade_date_begin = this.params.trade_date[0] ? App.oDate.secsTime3(this.params.trade_date[0]
						._d) : '',
					//認購截止日期
					this.params.trade_date_end = this.params.trade_date[1] ? App.oDate.secsTime3(this.params.trade_date[1]
						._d) : '';

				this.params.createdate_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					this.params.createdate_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handclose(val) {
				if(val){
					this.messLoad();
				}
			},
			messLoad() {
				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getQmisUserList,
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.qmisUserList
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.username || this.params.tradecode || this.params.tradetype || this.params.otherinfo || this.this.params.trade_date_begin) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = false;
				this.messLoad();
			},
			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					username: '',
					market: '',
					trade_date_begin: '', //認購起始日期
					trade_date_end: '', //認購截止日期
					createdate_begin: '',
					createdate_end: '',
					tradetype: '',
					otherinfo: '',
					timeDate: [],
					trade_date: [],
					missionflag: false
				}
				this.messLoad();
			},
			messionEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = this.params.missionflag ? false : true
				this.messLoad();
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
			// 详情点击事件
			detailsClick(val){
				this.isdate = val;
				console.log("这里是点击事件",val);
				this.customerInfoFlag = true;
			},
			customerInfoClick(){
				this.customerInfoFlag = false;
				this.messLoad();
			},						
			exchangeRateClick(){
				this.exchangeRateFlag = false;
			},						
			depositClick(){
				this.depositFlag = false;
				this.messLoad();
			},						
		},
	};
</script>
<style lang='scss'>

	#custinforma {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>